import React from "react";

const DotLoader = ({ size = 22, color = "#ffffff", style, className }) => (
  <div
    className={`dot_loader${className ? ` ${className}` : ""}`}
    style={{ width: size, "--dot-loader-color": color, ...style }}
  />
);

export default DotLoader;
